"use strict";

define('view/report/report.detail',['require','exports','module','underscore','backbone','uikit/uikit','../../libs/route.helper','../table.selected.add','./report.columns','../../templates','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var UIKit = require('uikit/uikit');
  var RouteHelper = require('../../libs/route.helper');
  var TableSelectedAdd = require('../table.selected.add');
  var ReportColumns = require('./report.columns');
  var Templates = require('../../templates');
  var langs = require('langs');
  function reportBreadcrumbList() {
    return [{
      text: 'Reports',
      link: RouteHelper.resolve('reporting:list')
    }, {
      text: 'Report Details'
    }];
  }
  function reportGroupName(name) {
    return name + ' Information';
  }
  function reportColumnTypeColor(type) {
    switch (type) {
      case 'study':
        return 'blue';
      case 'audit':
        return 'green';
    }
  }
  function animateRemoveReportColumn(el) {
    return new Promise(function (resolve, reject) {
      el.transition({
        animation: 'scale',
        onComplete: function onComplete() {
          resolve();
        }
      });
    });
  }
  function animateSwapReportColumns(c1, c2) {
    var c1Offset = c1.offset().top,
      c2Offset = c2.offset().top,
      positionChange = null;
    if (c2Offset > c1Offset) {
      positionChange = c2Offset - c1Offset;
    } else {
      positionChange = -(c1Offset - c2Offset);
    }
    return Promise.resolve(c1.animate({
      top: positionChange,
      queue: false
    }).promise(), c2.animate({
      top: -positionChange,
      queue: false
    }).promise());
  }
  var ModifiedAccordion = UIKit.Accordion.extend({
    template: Templates.IRB['report.accordion'],
    attributes: {
      role: 'menu',
      'aria-label': langs.phrase('ReportingPage.Details.ColumnOptions.ARIALabel')
    }
  });
  var ReportDetailView = UIKit.ItemView.extend({
    template: Templates.IRB['report.detail'],
    options: {
      columns: null,
      selectedColumns: null,
      changesHelper: null
    },
    modelEvents: {
      'sync': 'updateCreateDetailActions'
    },
    internalViews: {
      reportColumns: ReportColumns,
      reportColumnGroups: ModifiedAccordion
    },
    internalViewOptions: function internalViewOptions() {
      return {
        breadcrumb: {
          collection: new Backbone.Collection(reportBreadcrumbList())
        },
        reportForm: {
          model: this.model
        },
        filterForm: {
          model: this.model
        },
        reportColumnGroups: {
          animateChildren: false
        },
        deleteBtn: {
          icon: 'trash',
          color: 'white',
          text: langs.phrase('ReportingPage.Details.Actions.Delete.Text'),
          visible: false,
          role: 'menuitem',
          ariaLabel: langs.phrase('ReportingPage.Details.Actions.Delete.ARIALabel')
        },
        exportBtn: {
          icon: 'file outline',
          color: 'white',
          text: langs.phrase('ReportingPage.Details.Actions.Export.Text'),
          visible: false,
          role: 'menuitem',
          ariaLabel: langs.phrase('ReportingPage.Details.Actions.Export.ARIALabel')
        },
        previewBtn: {
          icon: 'list',
          color: 'white',
          text: langs.phrase('ReportingPage.Details.Actions.Preview.Text'),
          role: 'menuitem',
          ariaLabel: langs.phrase('ReportingPage.Details.Actions.Preview.ARIALabel')
        },
        saveBtn: {
          icon: 'save',
          color: 'primary',
          disabled: true,
          text: langs.phrase('ReportingPage.Details.Actions.Save.Text'),
          role: 'menuitem',
          ariaLabel: langs.phrase('ReportingPage.Details.Actions.Save.ARIALabel')
        }
      };
    },
    initialize: function initialize() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);
      this.setupReportForm();
      this.setupFilterForm(this.getOption('reportFilterBarView'));
      this.setupSelectedColumns();
      this.setupAvailableColumns();
      this.updateSelectedColumns();
      this.setupListeners();
      this.updateCreateDetailActions();
    },
    onFirstRender: function onFirstRender() {
      var self = this;
      _.defer(function () {
        self.reportColumnGroups.open(0);
      });
    },
    setupAvailableColumns: function setupAvailableColumns() {
      var availableColumns = this.getOption('columns'),
        selectedColumns = this.getOption('selectedColumns'),
        availableGroups = availableColumns.groupBy(function (c) {
          return c.get('type').description;
        }),
        self = this;
      this.reportColumnGroups.$el.addClass('semi-styled');
      this.reportColumnGroups.collection.reset([]);
      _.each(availableGroups, function (items, groupName) {
        var defs = [{
            data: ''
          }, {
            data: 'displayName'
          }, {
            align: 'right',
            childView: TableSelectedAdd
          }],
          collection = new Backbone.Collection(items, {
            comparator: 'displayName'
          }),
          table = new UIKit.Table({
            borderless: true,
            headless: true,
            collection: collection,
            columns: defs,
            unstackable: true
          }),
          text = reportGroupName(groupName);
        self.reportColumnGroups.collection.add({
          text: text,
          view: table,
          icon: 'dropdown',
          color: reportColumnTypeColor(groupName.toLowerCase())
        });
        table.listenTo(selectedColumns, 'add', function (c) {
          if (this.collection.indexOf(c) !== -1) {
            this.collection.remove(c, {
              animate: false
            });
          }
        }).listenTo(selectedColumns, 'remove', function (c) {
          if (groupName == c.get('type').description) {
            this.collection.add(c);
          }
        });
        self.listenTo(table, 'row:add', function (row) {
          self.addSelectedColumn(row.model);
        }).listenTo(table, 'row:double:press', function (row) {
          self.addSelectedColumn(row.model);
        });
      });
    },
    setupSelectedColumns: function setupSelectedColumns() {
      this.selectedColumns = new Backbone.Collection();
      this.reportColumns.collection = this.selectedColumns;
    },
    setupReportForm: function setupReportForm() {
      this.reportForm.addField({
        text: 'Report Name',
        required: true
      }, new UIKit.Input({
        name: 'name',
        model: this.model,
        bindings: {
          value: 'name'
        }
      }));
    },
    setupFilterForm: function setupFilterForm(reportFilterBarView) {
      this.filterForm.addField({
        text: 'Report Filters',
        required: false
      }, reportFilterBarView);
    },
    setupListeners: function setupListeners() {
      var changesHelper = this.getOption('changesHelper'),
        availableColumns = this.getOption('columns'),
        selectedColumns = this.getOption('selectedColumns');
      this.listenTo(changesHelper, 'change:changes', this.updatePageActions);
      this.listenTo(selectedColumns, 'add remove', _.debounce(this.updateReportSelectedColumns));
      this.listenTo(this.reportColumns, 'childview:columnOptions:press', function (columnView, dropdown, dropdownItem) {
        switch (dropdownItem.get('action')) {
          case 'moveDown':
            this.moveSelectedColumn(columnView, 'down');
            break;
          case 'moveUp':
            this.moveSelectedColumn(columnView, 'up');
            break;
          case 'remove':
            this.removeSelectedColumn(columnView);
            break;
        }
      });
      this.listenTo(this.filterForm, 'childview:childview:visualsearchView:token:editing', function () {
        this.previewBtn.disabled = true;
        this.saveBtn.disabled = true;
      });
      this.listenTo(this.filterForm, 'childview:childview:visualsearchView:token:complete childview:childview:visualsearchView:token:close', function () {
        this.updatePageActions();
      });
    },
    moveSelectedColumn: function moveSelectedColumn(columnView, direction) {
      var selectedColumns = this.selectedColumns,
        firstIndex = selectedColumns.models.indexOf(columnView.model),
        secondIndex = direction === 'down' ? firstIndex + 1 : firstIndex - 1,
        column1 = columnView.model,
        column2 = selectedColumns.models[secondIndex],
        columnView2 = this.reportColumns.children.findByModel(column2);
      animateSwapReportColumns(columnView.$el, columnView2.$el).bind(this).tap(function () {
        columnView2.$el.css('top', 'auto');
        selectedColumns.remove(column1);
        selectedColumns.add(column1, {
          at: secondIndex
        });
      });
    },
    addSelectedColumn: function addSelectedColumn(column) {
      var availableColumns = this.getOption('columns'),
        selectedColumns = this.getOption('selectedColumns');
      availableColumns.remove(column);
      selectedColumns.add(column);
    },
    removeSelectedColumn: function removeSelectedColumn(columnView) {
      var column = columnView.model;
      animateRemoveReportColumn(columnView.$el).bind(this).tap(function () {
        this.selectedColumns.remove(column);
        this.columns.add(column);
      });
    },
    updateCreateDetailActions: function updateCreateDetailActions() {
      var newModel = this.model.isNew();
      this.deleteBtn.visible = !newModel;
      this.exportBtn.visible = !newModel;
    },
    updatePageActions: function updatePageActions() {
      var selectedColumns = this.getOption('selectedColumns'),
        numOfColumns = selectedColumns.length,
        changes = this.getOption('changesHelper').get('changes');
      this.previewBtn.disabled = numOfColumns === 0;
      this.exportBtn.disabled = numOfColumns === 0 || changes;
      this.saveBtn.disabled = !changes;
    },
    updateReportSelectedColumns: function updateReportSelectedColumns() {
      var selectedColumns = this.getOption('selectedColumns');
      this.model.setColumns(selectedColumns);
      this.updatePageActions();
    },
    updateSelectedColumns: function updateSelectedColumns() {
      var data = this.model.get('columns'),
        available = this.getOption('columns'),
        selected = this.getOption('selectedColumns');
      _.each(data, function (c) {
        var column = available.findWhere({
          name: c.name
        });
        selected.add(column);
      });
      this.updatePageActions();
    },
    onReportColumnGroupsRender: function onReportColumnGroupsRender() {
      this.reportColumnGroups.$el.find('.title > .icon').css('float', 'right');
    },
    onExportBtnPress: function onExportBtnPress() {
      this.triggerMethod('report:export');
    },
    onSaveBtnPress: function onSaveBtnPress() {
      this.triggerMethod('report:save');
    },
    onDeleteBtnPress: function onDeleteBtnPress() {
      this.triggerMethod('report:delete');
    },
    onPreviewBtnPress: function onPreviewBtnPress() {
      this.triggerMethod('report:preview');
    }
  });
  module.exports = ReportDetailView;
});

